import { useFormSelector } from 'mrf/redux/ReduxHelper';
// import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';
import FormCRUD from 'mrf/view/FormCRUD';
import FormQueryObjectField from 'mrf/view/FormQueryObjectField';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import React from 'react';
import role from 'role';

export default function RootTermForm({ history, match }) {

    const context = useFormSelector({
        id: match?.params?.id,
        resource: 'rootTerms',
    });

    const rootTermTypeFields = [
        { name: 'Id', key: 'id' },
        { name: 'Root Term Type Name (EN)', key: 'termTypeNameEN' },
        { name: 'Root Term Type Name (ES)', key: 'termTypeNameES' },
    ];

    return <FormCRUD
        title='Root Term'
        match={match}
        history={history}
        context={context}
        roleForDelete={[role.ADMIN]}
    >
        <Grid>
            <Col size={4}>
                <FormQueryObjectField
                    label='Root Term Type'
                    resource='rootTermTypes'
                    endpoint={'/api/rootTermTypes'}
                    displayAttribute='termTypeNameEN'
                    field='rootTermTypeId'
                    fields={rootTermTypeFields}
                    formEndpoint='/api/rootTermTypes'
                    disableRemove={true}
                    disableAdd
                    required
                />
            </Col>
            <Col size={4}>
                <TextField
                    label='Root Term Name (EN)'
                    field='rootTermNameEN'
                    required
                />
            </Col>
            <Col size={4}>
                <TextField
                    label='Root Term Name (ES)'
                    field='rootTermNameES'
                    required
                />
            </Col>
        </Grid>
    </FormCRUD>
}